export const EDIT_CLUB_SUBSCRIPTION_SHIPMENT_ITEMS_REQUEST =
  'EDIT_CLUB_SUBSCRIPTION_SHIPMENT_ITEMS_REQUEST';
export const EDIT_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_REQUEST =
  'EDIT_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_REQUEST';
export const RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_REQUEST =
  'RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_REQUEST';
export const RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_SUCCESS =
  'RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_SUCCESS';
export const GET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_SUCCESS =
  'GET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_SUCCESS';
export const PROCESS_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST =
  'PROCESS_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST';
export const SKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST =
  'SKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST';
export const UNSKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST =
  'UNSKIP_CLUB_SUBSCRIPTION_SHIPMENT_REQUEST';

export const GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS =
  'GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS';
export const LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS =
  'LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS';

export const GET_CLUB_SUBSCRIPTION_SHIPMENT_SKIP_UNSKIP_SUCCESS =
  'GET_CLUB_SUBSCRIPTION_SHIPMENT_SKIP_UNSKIP_SUCCESS';
export const GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_REQUEST =
  'GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_REQUEST';
export const GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS =
  'GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS';
